'use strict';

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _fontfaceobserver = require('fontfaceobserver/fontfaceobserver');

var _fontfaceobserver2 = _interopRequireDefault(_fontfaceobserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fontObservers = [];

var fontFamilies = {
    'Plastic Sans': [{ weight: 700 }],
    'Open Sans': [{ weight: 600 }, { weight: 700 }, {}]
};

(0, _keys2.default)(fontFamilies).forEach(function (family) {

    var key = stringToKey(family);

    if (!sessionStorage.getItem(key)) {
        fontObservers.push(fontFamilies[family].map(function (config) {
            return new _fontfaceobserver2.default(family, config).load();
        }));
    } else {
        fontLoaded(key);
    }
});

fontObservers.forEach(function (observer) {
    _promise2.default.all(observer).then(function (result) {
        var key = stringToKey(result[0].family);
        fontLoaded(key);
    });
});

function fontLoaded(key) {
    sessionStorage.setItem(key, 'true');
    document.documentElement.className += ' ' + key + '-loaded';
}

function stringToKey(string) {
    return string.toLowerCase().replace(' ', '-');
}


//////////////////
// WEBPACK FOOTER
// ./src/app/fontloader/index.js
// module id = 422
// module chunks = 5